import React, { FunctionComponent, useContext } from 'react';
import AccountSetup from 'libraries/wizard/components/account-setup';
import useInvestmentAccountCreation from 'subapps/investment/pages/investment/wizard-steps/account-setup/use-investment-account-creation';
import useProcessOverview from 'subapps/investment/pages/investment/wizard-steps/account-setup/use-process-overview';
import WizardContext from 'src/libraries/wizard/wizard-context';

const AccountSetupStep: FunctionComponent<{}> = () => {
  const accountCreationProps = useInvestmentAccountCreation();
  const overviewSteps = useProcessOverview();

  const { onCloseProcessOverviewOverlay, showProcessOverview } = useContext(WizardContext);

  return (
    <AccountSetup
      {...accountCreationProps}
      {...overviewSteps}
      onCloseProcessOverviewOverlay={onCloseProcessOverviewOverlay}
      showProcessOverview={showProcessOverview}
    />
  );
};

export default AccountSetupStep;
